import { Dispatch, SetStateAction } from "react";
import { SegmentNameUnion } from "pages/RequestIndex/hooks";

export type RequestIndexPage = "active" | "past";

/**
 * Saved filter state for the v2 request index. Unlike v1 this holds a plain day
 * rather than a `dateOption` + custom range, under its own localStorage key so
 * the two versions never read each other's shape.
 */
export type FilterValues = {
  /** ISO date (`yyyy-MM-dd`) the index is filtered to; `undefined` is "All Dates". */
  date?: string;
  statuses: Array<SegmentNameUnion>;
  schools: Array<string>;
};

export type ThreadedData = {
  page: RequestIndexPage;
  ls: FilterValues;
  setLs: Dispatch<SetStateAction<FilterValues>>;
};

export const initialFilterValues: FilterValues = {
  date: undefined,
  statuses: [],
  schools: [],
};
